import React from "react";
import { ChatConfigData, MessageConfigFromPostConfig, PostConfigData } from "../Shared/Party/PartyConfigData";
import { Post, PostDisplayProps } from "./Post";
import { StateManagerContext } from "./StateManagerContext";
import { Carousel } from "./Carousel";
import { UIConfigContext } from "./UIConfigContext";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";
import { CloneUserAction, UserAction } from "../Shared/UserData";
import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { BoostLevels } from "./ReplyPanel";

export type ActionSharePanelProps = {
    action: UserAction
    height: number;
    onFinish: () => void;
    onQuit: () => void;
}

type PostSharePanelState = 'select' | 'display' | 'processing' | 'thankyou';

const subsitute = (texts: string[], parameters: { [key: string]: string }): string[] => {
    const ret = texts.map((text) => {
        var str = text;
        Object.keys(parameters).forEach((key) => {
            const ch = '{' + key + '}';
            if (str.includes(ch)) {
                str = str.replace(ch, parameters[key]);
            }
        });
        return str;
    })
    return ret;
}

export const ActionSharePanel = ({ action, height, onFinish }: ActionSharePanelProps): JSX.Element => {

    const uiConfig = React.useContext(UIConfigContext);
    const config = action.config;
    const postRef = React.useRef<PostConfigData>(((): PostConfigData => {
        const ret: PostConfigData = {
            itemId: action.itemId,
            title: '',
            author: '@FANBOX',
            layout: 'single-element',
            rotate: 'none',
            messageDisplay: 'none',
            elements: [{
                itemId: action.itemId + '_0',
                layout: 'primary-left',
                primary: {

                },

            }]
        };
        if (action.config.buttonAction !== undefined) {
            ret.elements[0].primary.buttonClick = action.config.buttonAction;
        }
        if (action.config.images.length > 0)
            ret.elements[0].secondary = {};
        return ret;
    })());
    const [panelState, setPanelState] = React.useState<PostSharePanelState>('select');
    const titleIndex = React.useRef<number>(0);
    const bodyIndex = React.useRef<number>(0);
    const buttonIndex = React.useRef<number>(0);
    const imageIndex = React.useRef<number>(0);
    const boostRef = React.useRef<number>(0);
    const setBoostSelect = (value: string) => {
         boostRef.current = parseInt(value); 
        };
    const titles = React.useRef<string[]>([]);
    const bodyTexts = React.useRef<string[]>([]);
    const buttonTexts = React.useRef<string[]>([]);
    const actionId = React.useRef<string>('');

    if (actionId.current !== action.itemId) {
        actionId.current = action.itemId;
        if (config.parameters !== undefined) {
            titles.current = subsitute(config.titles, config.parameters);
            bodyTexts.current = subsitute(config.texts, config.parameters);
            buttonTexts.current = subsitute(config.buttonTexts, config.parameters);
        }
        else {
            titles.current = config.titles;
            bodyTexts.current = config.texts;
            buttonTexts.current = config.buttonTexts;
        }

    }

    const updateTitleIndex = (index: number) => { titleIndex.current = index; }
    const updateBodyIndex = (index: number) => { bodyIndex.current = index; }
    const updateButtonIndex = (index: number) => { buttonIndex.current = index; }
    const updateImageIndex = (index: number) => { imageIndex.current = index; }


    const stateManager = React.useContext(StateManagerContext);
    const boosts = stateManager.user().accountInformation.boostBalance;

    const postHandler: ActionHandler = (_action) => {
        return true;
    }

    const postDisplayProps: PostDisplayProps = {
        postHeight: Math.min(500, height - 102),
        postWidth : uiConfig.width- 32,
        messageHeight: 0,
        userId: stateManager.user().fanbox.id,
        showLikeCommentButtons: false,
        actionHandler: postHandler,
        disableButtons : true
    }

    const gotoPreview: ActionHandler = (_action) => {
        postRef.current.title = titles.current[titleIndex.current];
        const pe = postRef.current.elements[0];
        pe.primary.text = bodyTexts.current[bodyIndex.current];
        if (buttonTexts.current.length > 0) {
            pe.primary.buttonClick = config.buttonAction ?? '';
            pe.primary.buttonText = buttonTexts.current[buttonIndex.current]
        }
        if (pe.secondary !== undefined)
            pe.secondary.imageSrc = config.images[imageIndex.current];
        setPanelState('display');
        return true;
    }

    const previewAction = CreateAction('preview', [{ permission: 'signedIn' }], gotoPreview);

    const buttonStyling: FanboxStyling = {
        width: uiConfig.width * 0.5,
        height: 50,
        boundary: {
            margin: {
                quadType: 'margin',
                top: 20,
                left: uiConfig.width * 0.25,
                right: 0,
                bottom: 0
            }
        },
        color: {
            background: 'orange',
            foreground: 'white'
        },
        font: {
            size: uiConfig.fontBase,
            weight: 'bold'
        }
    }

    const doShare: ActionHandler = (_action) => {

        //const [message, chatId] = MessageConfigFromPostConfig(postRef.current, action.multiplier, boostRef.current, stateManager.activity().national, 0, stateManager.user().fanbox.id);
        //stateManager.addUserMessage(message, chatId);

        const worker = async () => {
            const data = {
                actionId: action.itemId,
                titleSelection: titleIndex.current,
                textSelection: bodyIndex.current,
                imageSelection: imageIndex.current,
                buttonTextSelection: buttonIndex.current,
                boosts: boostRef.current,
                userId: stateManager.user().fanbox.id,
                accessToken: stateManager.user().fanbox.accessToken
            }
            const uri = '/api/user/completeaction';
            const response = await fetch(uri, {
                method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify(data)
            });
            const json = await response.json();

           
            const newAction = json.action as UserAction;
            CloneUserAction(action, newAction);
            setPanelState('thankyou');
        }
        worker();


        setPanelState('processing');
        return true;
    }

    const doShareAction = CreateAction('doShare', [{ permission: 'signedIn' }], doShare);

    const doFinish: ActionHandler = (_action) => {
        onFinish();
        return true;
    }

    const doFinishAction = CreateAction('doFinish', [], doFinish);


    return (
        <div style={{
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: height + 'px',
            minHeight: height + 'px',
            maxHeight: height + 'px',
            overflow : 'auto'
            
        }}
        className="scrollablePanel">
            <div style={{
                width: uiConfig.width + 'px',
                minWidth: uiConfig.width + 'px',
                maxWidth: uiConfig.width + 'px',
                minHeight : height + 'px',
                backgroundColor: uiConfig.contolBackground,
                display: 'flex',
                flexDirection: 'column'}}>
                {(panelState === 'select') && <span style={{ fontSize: (uiConfig.fontBase * 2) + 'px', fontWeight: 700, fontFamily: 'roboto', color: '#ffff54' }}>Select your post title</span>}
                {(panelState === 'select') && <Carousel width={uiConfig.width} height={50} display={1} scrollButtonWidth={20} idPrefix="PostSharePanelTitleSelect" userControlled={true} panels={
                    titles.current.map((title) => {
                        return <div style={{ width: uiConfig.width + 'px', maxWidth: uiConfig.width + 'px', minWidth: uiConfig.width + 'px', height: '50px', minHeight: '50px', display : 'flex', justifyContent : 'center', alignItems : 'center' }}><span style={{ fontSize: (uiConfig.fontBase * 1.5) + 'px', fontWeight: 400, fontFamily: 'roboto', color: 'white', margin: 'auto' }}>{title}</span></div>
                    })
                } notifyOnClick={updateTitleIndex} />}

                {(panelState === 'select') && <span style={{ fontSize: (uiConfig.fontBase * 2) + 'px', fontWeight: 700, fontFamily: 'roboto', color: '#ffff54' }}>Select your body text</span>}
                {(panelState === 'select') && <Carousel width={uiConfig.width} height={200} display={1} scrollButtonWidth={20} idPrefix="PostSharePanelTextSelect" userControlled={true} panels={
                    bodyTexts.current.map((text) => {
                        return <div style={{ width: (uiConfig.width) + 'px', maxWidth: (uiConfig.width) + 'px', minWidth: (uiConfig.width) + 'px', height: '200px', minHeight: '200px' , display : 'flex', justifyContent : 'center', alignItems : 'center' }}><div style={{maxWidth: (uiConfig.width-60) + 'px'}}><span style={{ fontSize: (uiConfig.fontBase * 1.5) + 'px', fontWeight: 400, fontFamily: 'roboto', color: 'white', margin: 'auto' , maxWidth: (uiConfig.width-40) + 'px'}}>{text}</span></div></div>
                    })
                } notifyOnClick={updateBodyIndex} />}

                {(panelState === 'select') && <span style={{ fontSize: (uiConfig.fontBase * 2) + 'px', fontWeight: 700, fontFamily: 'roboto', color: '#ffff54' }}>Select your image</span>}
                {(panelState === 'select') && <Carousel width={uiConfig.width} height={400} display={1} scrollButtonWidth={20} idPrefix="PostSharePanelImageSelect" userControlled={true} panels={
                    config.images.map((src) => {
                        return <div style={{ width: uiConfig.width + 'px', maxWidth: uiConfig.width + 'px', minWidth: uiConfig.width + 'px', height: '400px', minHeight: '300px', backgroundImage: 'url(' + src + ')', backgroundPosition: 'center', backgroundSize : 'contain', backgroundRepeat : 'no-repeat' }}></div>
                    })
                } notifyOnClick={updateImageIndex} />}

                {(panelState === 'select' && buttonTexts.current.length > 1) && <span style={{ fontSize: (uiConfig.fontBase * 2) + 'px', fontWeight: 700, fontFamily: 'roboto', color: '#ffff54' }}>Select your Button Text</span>}
                {(panelState === 'select' && buttonTexts.current.length > 1) && <Carousel width={uiConfig.width} height={50} display={1} scrollButtonWidth={20} idPrefix="PostSharePanelButtonTextSelect" userControlled={true} panels={
                    buttonTexts.current.map((text) => {
                        return <div style={{ width: uiConfig.width + 'px', maxWidth: uiConfig.width + 'px', minWidth: uiConfig.width + 'px', height: '50px', minHeight: '50px' , display : 'flex', justifyContent : 'center', alignItems : 'center' }}><span style={{ fontSize: (uiConfig.fontBase * 1.5) + 'px', fontWeight: 400, fontFamily: 'roboto', color: 'white', margin: 'auto' }}>{text}</span></div>
                    })
                } notifyOnClick={updateButtonIndex} />}
                {(panelState === 'select') && <InputLabel id='message-boost-select-label'>Select how many boosted impressions you want</InputLabel>}
                {(panelState === 'select') && <Select
                    labelId="message-boost-select-label"
                    id="message-boost-select"
                    label="Boost Level"
                    onChange={(ev: SelectChangeEvent) => { setBoostSelect(ev.target.value) }}
                    sx={{
                        color: 'white',
                        backgroundColor: '#303030',
                        fontSize: uiConfig.fontBase,
                        borderRadius: '8px',
                        marginTop: '10px',
                        marginLeft: '30px',
                        marginRight: '30px',
                        marginBottom: '10px',
                    }}
                >
                    {BoostLevels.map((row, index) => {
                        if (row.boosts <= boosts)
                            return <MenuItem value={row.boosts} key={'ReplyPanel_BoostSelect_' + index}>{row.label}</MenuItem>
                    })}

                </Select>}
                {(panelState === 'select') && <ActionButton text={'Preview'}
                    action={previewAction}
                    actionData={EmptyActionData}
                    styling={buttonStyling}
                    prompt={'right'} />}
                {(panelState === 'display') && <span style={{ fontSize: (uiConfig.fontBase * 2) + 'px', fontWeight: 700, fontFamily: 'roboto', color: 'white' }}>Preview</span>}
                {(panelState === 'display') && <div style = {{padding : '16px', backgroundColor : uiConfig.fanboxColor('darkGray'), boxShadow : '0 4px 12px rgb(0,0,0,0.1)'}}><Post config={postRef.current} display={postDisplayProps} /></div>}
                {(panelState === 'display') && <ActionButton text={'Share'}
                    action={doShareAction}
                    actionData={EmptyActionData}
                    styling={buttonStyling}
                    prompt={'left'} />}
                {(panelState ==='processing') && <span style={{
                    fontSize: uiConfig.fontBase * 1.5,
                    fontWeight: 600,
                    fontFamily: 'roboto',
                    color: 'white'

                }} >Thank you for your share. The server is currently processing your post, this may take a few seconds .</span>

                }
                {(panelState === 'thankyou') && <span style={{
                    fontSize: uiConfig.fontBase * 1.5,
                    fontWeight: 600,
                    fontFamily: 'roboto',
                    color: 'white'

                }} >Thank you for your share. We are currently moderating and scheduling your post to distribute to other fans. You can check back here in a few mins or on your posts panle, where your post will appear with your other user messages and you can see how many likes it is getting as well as the comments being made.</span>

                }
                {
                    (panelState === 'thankyou') && <ActionButton text={'Finish'}
                        action={doFinishAction}
                        actionData={EmptyActionData}
                        styling={buttonStyling}
                        prompt={'left'} />
                }
            </div>
        </div>
    );




}